export enum BrandingFields {
  backgroundColor = 'backgroundColor',
  tertiaryColor = 'tertiaryColor',
  primaryColor = 'primaryColor',
  secondaryColor = 'secondaryColor',
  highlightColor = 'highlightColor',
  headlineColor = 'headlineColor',
  primaryCtaColor = 'primaryCtaColor',
  secondaryCtaColor = 'secondaryCtaColor',
  logoUrl = 'logoUrl',
  backgroundImageUrl = 'backgroundImageUrl',
  messageHeader = 'messageHeader',
  backgroundSize = 'backgroundSize',
  backgroundImageId = 'backgroundImageId',
  logoId = 'logoId',
  termsUrl = 'termsUrl',
  privacyPolicyLink = 'privacyPolicyLink',
  contactSupportLink = 'contactSupportLink',
  disclaimer = 'disclaimer',
  giftCardConfirmationMessaging = 'giftCardConfirmationMessaging',
  companyName = 'companyName',
}

export interface IBrandingColorParams {
  [BrandingFields.backgroundColor]: string;
  [BrandingFields.tertiaryColor]: string;
  [BrandingFields.primaryColor]: string;
  [BrandingFields.secondaryColor]: string;
  [BrandingFields.highlightColor]: string;
  [BrandingFields.headlineColor]: string;
  [BrandingFields.primaryCtaColor]: string;
  [BrandingFields.secondaryCtaColor]: string;
  [BrandingFields.messageHeader]: string;
  [BrandingFields.termsUrl]?: string;
  [BrandingFields.privacyPolicyLink]: string;
  [BrandingFields.contactSupportLink]: string;
  [BrandingFields.disclaimer]?: string | null;
  [BrandingFields.giftCardConfirmationMessaging]?: string | null;
  [BrandingFields.companyName]: string;
}

export interface IBrandingParams extends IBrandingColorParams {
  [BrandingFields.logoUrl]: string | null;
  [BrandingFields.backgroundImageUrl]: string | null;
  [BrandingFields.backgroundSize]: string | null;
}

export interface IBranding extends IBrandingParams {
  [BrandingFields.logoId]: number;
  [BrandingFields.backgroundImageId]: number;
}
